import { render, staticRenderFns } from "./ClientsClientDetails.vue?vue&type=template&id=0707bef9&scoped=true&"
import script from "./ClientsClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientsClientDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707bef9",
  null
  
)

export default component.exports